import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Home, Compass, Mic, MessageCircle, User } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();
  const [unread, setUnread] = useState(0);

  useEffect(() => {
    let alive = true;
    const poll = () => api.get("/messages/unread-count").then(({ data }) => alive && setUnread(data.count)).catch(() => {});
    poll();
    const t = setInterval(poll, 25000);
    return () => { alive = false; clearInterval(t); };
  }, [location.pathname]);

  const tabs = [
    { key: "home", label: "Home", icon: Home, path: "/" },
    { key: "explore", label: "Explore", icon: Compass, path: "/explore" },
    { key: "golive", center: true },
    { key: "messages", label: "Messages", icon: MessageCircle, path: "/messages" },
    { key: "profile", label: "Profile", icon: User, path: user ? `/profile/${user.id}` : "/profile" },
  ];
  const isActive = (t) =>
    t.path === "/" ? location.pathname === "/" : location.pathname.startsWith(t.path.split("/").slice(0, 2).join("/"));

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 max-w-md mx-auto" data-testid="bottom-nav">
      <div className="relative bg-[#14101F]/80 backdrop-blur-2xl border-t border-[rgba(255,216,107,0.25)] px-2 pt-1.5 pb-[max(1rem,env(safe-area-inset-bottom))]">
        <div className="flex items-end justify-around">
          {tabs.map((t) =>
            t.center ? (
              <button key={t.key} data-testid="nav-golive" onClick={() => navigate("/go-live")}
                className="relative -top-6 active:scale-95 transition-transform">
                <span className="flex w-16 h-16 rounded-full gradient-primary items-center justify-center shadow-[0_0_24px_rgba(255,46,151,0.45),0_8px_24px_rgba(160,60,245,0.35)] ring-4 ring-[#0B0B14]">
                  <Mic size={24} className="text-white" strokeWidth={2.4} />
                </span>
                <span className="block text-[10px] font-extrabold text-[#FFD86B] text-center mt-1 tracking-wide">GO LIVE</span>
              </button>
            ) : (
              <button key={t.key} data-testid={`nav-${t.key}`} onClick={() => navigate(t.path)}
                className={`relative flex flex-col items-center gap-0.5 px-3 py-1 transition-colors ${isActive(t) ? "text-[#FFD86B]" : "text-[#6E6683]"}`}>
                <t.icon size={20} strokeWidth={isActive(t) ? 2.5 : 2} fill={isActive(t) ? "currentColor" : "none"} />
                {t.key === "messages" && unread > 0 && (
                  <span data-testid="messages-unread-dot" className="absolute top-0 right-2 w-2 h-2 rounded-full bg-[#FF4D8D] shadow-[0_0_6px_#FF4D8D]" />
                )}
                <span className="text-[10px] font-bold">{t.label}</span>
              </button>
            )
          )}
        </div>
      </div>
    </div>
  );
}
